import { PulseLoader } from "react-spinners";
import LazyLoadTable from "./lazy-table";
import { useEffect, useRef, useState } from "react";

export default function LeaderboardTable({ entrants, isLoading }) {
  const positionImages = {
    first: require("../../../../assets/images/first-place.svg"),
    second: require("../../../../assets/images/second-place.svg"),
    third: require("../../../../assets/images/third-place.svg"),
  };

  function positionIcon(position) {
    if (position === 1) {
      return positionImages["first"];
    }

    if (position === 2) {
      return positionImages["second"];
    }

    if (position === 3) {
      return positionImages["third"];
    }

    return null;
  }

  const columns = ["position", "customer", "contact", "location", "points"];
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }
  }, [containerRef.current]);

  return (
    // <div className="w-full px-4">
    //   <div ref={containerRef} className="w-full">
    //     {width && (
    //       <LazyLoadTable
    //         data={entrants}
    //         columns={columns}
    //         width={width}
    //         positionIcon={positionIcon}
    //       />
    //     )}
    //   </div>
    // </div>
    <div className="min-h-[70vh]">
      <table className="w-full  bg-white border-b-lg shadow">
        <thead className="bg-[#F4F4F4] rounded py-2">
          <tr>
            <th className="text-center px-6 py-5 md:text-sm text-xs font-normal ">
              Position
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal "></th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Customer
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal ">
              Contact
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal">
              Location
            </th>
            <th className="text-left px-6 py-5 md:text-sm text-xs font-normal">
              Points
            </th>
          </tr>
        </thead>

        <tbody className="text-[#848484]">
          {isLoading && (
            <tr className="w-full">
              <td className="text-center" colSpan="5">
                <div className="my-8 mx-auto">
                  <PulseLoader color="#FF6A3A" />
                </div>
              </td>
            </tr>
          )}

          {entrants?.length === 0 && !isLoading && (
            <tr className="w-full">
              <td className="text-center" colSpan="5">
                <div className="my-8 mx-auto">
                  <img
                    src={require("../../../../assets/images/noData.svg")}
                    alt=""
                    className="mx-auto"
                  />
                </div>
              </td>
            </tr>
          )}
          {
            entrants?.length > 0 &&
              entrants?.map((entrant, index) => (
                <tr
                  key={index}
                  className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4] focus:cursor-pointer "
                >
                  <td className="px-6 whitespace-nowrap  text-xs md:text-sm py-6 text-center">
                    {entrant?.position}
                  </td>
                  <td className="px-6 whitespace-nowrap  md:text-sm  px-auto">
                    {positionIcon(entrant?.position) ? (
                      <img
                        src={positionIcon(entrant?.position)}
                        alt=""
                        className="w-4 object-cover"
                      />
                    ) : null}
                  </td>
                  <td className=" whitespace-nowrap  text-xs md:text-sm  text-left">
                    {entrant?.name}
                  </td>
                  <td className=" text-left whitespace-nowrap px-6 text-xs md:text-sm py-6 ">
                    {entrant?.userId}
                  </td>
                  <td className=" text-left whitespace-nowrap px-6 text-xs md:text-sm py-6 ">
                    {entrant?.location}
                  </td>
                  <td className=" text-left whitespace-nowrap px-6 text-xs md:text-sm py-6 ">
                    {entrant?.loyaltyPoints}
                  </td>
                </tr>
              ))
            // .slice(indexOfFirstPage, indexOfLastPage)
          }
        </tbody>
      </table>
    </div>
  );
}
